import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import {
  CURRENCY_NAME,
  CUSTOM_SELECT_STYLES,
  SELECT_BOX_THEME,
  SUBSCRIPTION_MODULE_TYPE,
  SUPPORTED_PAYMENT_METHOD_LIST,
  PUSH_NOTIFICATION_MODULE,
  appUrl,
} from "../../constants";
import { addSubscriptionAction } from "../../actions/subscription";
import { useDispatch, useSelector } from "react-redux";
import { createChat } from "../../services/api";
import { simpleUploadAction } from "../../actions/files";

export const paymentLink = (data) => {
  return `<a class="chatPaymentLink" href="javascript:void(0)" slug="${data?.slug}">Admin has requested a payment</a>`;
};

export default function CreatePayment({ show, onClose, conversation }) {
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);

  const [attachments, setAttachments] = useState([]);
  const [isKimbocorp, setIsKimbocorp] = useState(false);

  const onCancel = () => {
    reset();
    setAttachments([]);
    setIsKimbocorp(false);
    onClose();
  };

  const handleFileUpload = async (e) => {
    const files = Array.from(e.target.files);

    for (let file of files) {
      const formData = new FormData();
      formData.append("file", file);

      try {
        const resp = await dispatch(simpleUploadAction(formData, true));

        if (resp) {
          setAttachments((prev) => [
            ...prev,
            {
              filename: resp?.filename,
              originalName: resp?.originalName,
            },
          ]);
        }
      } catch (err) {
        console.log("Upload error", err);
      }
    }
  };
  const removeFile = (index) => {
    const updated = attachments.filter((_, i) => i !== index);
    setAttachments(updated);
  };

  const onSubmit = async (data) => {
    const allData = {
      planType: { value: SUBSCRIPTION_MODULE_TYPE.CUSTOM, name: "Custom" },
      name: data.planName,
      isActive: true,
      currency: data.currency,
      price: data.price,
      targetAudience: data.targetAudience,
      supportedPaymentMethod: SUPPORTED_PAYMENT_METHOD_LIST,
      type: 'kimbocorp',
      attachment: attachments.map((f) => f.filename),
      smallDescription:
        "this plan allows you to access premium features...",
    };

    const result = await dispatch(addSubscriptionAction(allData));
    if (result?.status) {
      const data = paymentLink(result.data)
      const innerValue = `Quotation: ${allData?.name}`;
      if (innerValue.length === 0) {
        return;
      }
      const attributes = {
        module: PUSH_NOTIFICATION_MODULE.PAYMENTLINK, // Custom attribute
        data: result.data,
        participants: conversation?.participants?.filter(x => x.id !== user?.id).map(x => x.id),
        message: innerValue
      };
      var channelRes = await createChat(attributes);
      onCancel();
    } else {
      onCancel();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      className="companyEdit-modal filter-modal"
    >
      {/* HEADER SAME */}
      <div className="modal-header pt-2">
        <button
          type="button"
          className="btn-close text-dark close-button"
          onClick={onClose}
        ></button>
      </div>

      <div className="modal-body">
        <div className="row">

          {/* Title */}
          <div className="col-6 fieldPadding">
            <label className="labelForm">Title*</label>
            <Controller
              control={control}
              name="planName"
              rules={{ required: true }}
              render={({ field }) => (
                <input
                  {...field}
                  maxLength={50}
                  className="form-control"
                  placeholder="Title"
                />
              )}
            />
            {errors.planName && (
              <span className="errorMessage">Title is required</span>
            )}
          </div>

          {/* Price */}
          <div className="col-6 fieldPadding">
            <label className="labelForm">Price*</label>
            <Controller
              control={control}
              name="price"
              rules={{ required: true }}
              render={({ field }) => (
                <input
                  {...field}
                  className="form-control"
                  placeholder="Price/Amount"
                />
              )}
            />
            {errors.price && (
              <span className="errorMessage">Price is required</span>
            )}
          </div>

          {/* Currency */}
          <div className="col-12 fieldPadding">
            <label className="labelForm">Currency*</label>
            <Controller
              name="currency"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Select
                  {...field}
                  options={CURRENCY_NAME}
                  styles={CUSTOM_SELECT_STYLES}
                  theme={SELECT_BOX_THEME}
                  placeholder="Choose currency..."
                  isClearable
                />
              )}
            />
          </div>

          {/* Description (textarea) */}
          <div className="col-12 fieldPadding">
            <label className="labelForm">Description*</label>
            <Controller
              control={control}
              name="targetAudience"
              rules={{ required: true }}
              render={({ field }) => (
                <textarea
                  {...field}
                  className="form-control"
                  rows={4}
                  placeholder="Enter plan description"
                />
              )}
            />
          </div>

          {/* Attachments */}
          <div className="col-12 fieldPadding mt-3  ">
            <label className="labelForm me-2">Attach files</label>
            <input type="file" multiple onChange={handleFileUpload} />

            {attachments.map((file, i) => (
              <div key={i} className="d-flex justify-content-between mt-2">
                <span>{appUrl + file.filename}</span>
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => removeFile(i)}
                >
                  Remove
                </button>
              </div>
            ))}
          </div>

          <div className="row bottomRow">
            <div className="col-md-6">
              <button
                onClick={onCancel}
                type="button"
                className="btn save-btn cancelButton"
              >
                Cancel
              </button>
            </div>

            <div className="col-md-6 mt-md-0 mt-2">
              <button
                type="submit"
                onClick={handleSubmit(onSubmit)}
                className="btn save-btn customConfirmButton"
              >
                Create Plan
              </button>
            </div>
          </div>

        </div>
      </div>
    </Modal>
  );
}